import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

function SliderLine({ current, total, onPrev, onNext, dark = false }) {
  const line = dark ? "bg-[rgba(255,255,255,0.4)]" : "bg-[rgba(0,0,0,0.3)]";
  const text = dark ? "text-[rgba(255,255,255,0.7)]" : "text-[rgba(0,0,0,0.7)]";

  return (
    <div className="mt-[18px] w-full">
      <div className={`h-px w-full ${line}`} />
      <div className="flex items-center justify-between pt-[6px]">
        <button onClick={onPrev} aria-label="Previous" className={text}>
          <ChevronLeft className="w-[24px] h-[24px]" strokeWidth={1} />
        </button>
        <p className={`font-['Inter'] text-[14px] ${text}`}>
          <span className="font-bold">{current + 1}</span> / {total}
        </p>
        <button onClick={onNext} aria-label="Next" className={text}>
          <ChevronRight className="w-[24px] h-[24px]" strokeWidth={1} />
        </button>
      </div>
    </div>
  );
}

export default SliderLine;
